import React, { useEffect, useState } from "react"; 
import { fmtNum } from "../../../../../shared/utils";
import api from "../../../../../services/api";

export const CreatEditAtividade = ({ 
    editingActivity, 
    activities, 
    setActivities, 
    showFlash, 
    setEditingActivity 
}) => {
    const [form, setForm] = useState({
        nome: "",
        unidade: "hora",
        ppu_rank: 10,
        ppu_token: 8,
        cor: "#4FB3A9",
        ordem: 0,
        ativo: true,
        max_token: "",
        max_pts: "",
        periodo: "dia",
    });

    const prev = () => {
        const mp = parseFloat(form.max_pts) || 0;
        if (!mp) return null;
        return mp;
    };

    const submit = async (e) => {
        e.preventDefault();
        if (!form.nome.trim()) {
          showFlash("Nome obrigatório.", "er");
          return;
        }
        const dados = {
          ...form,
          nome: form.nome.trim(),
          ppu_rank: parseFloat(form.ppu_rank) || 0,
          ppu_token: parseFloat(form.ppu_token) || 0,
          ordem: Number(form.ordem) || 0,
          max_token: form.max_token !== "" ? Number(form.max_token) : null,
          max_pts: form.max_pts !== "" ? Number(form.max_pts) : null,
        };
        try {
          const response = editingActivity
            ? await api.put(`/activities?id=${editingActivity}`, dados)
            : await api.post("/activities", dados);
          const saved = response.data?.data ?? response.data;
          if (editingActivity) {
            setActivities(
              activities.map((a) => (a.id === editingActivity ? saved : a)),
            );
            showFlash("Atualizada.", "in");
          } else {
            setActivities([...activities, saved]);
            showFlash("Cadastrada.");
          }
          setEditingActivity(null);
        } catch (err) {
          showFlash(
            err.response?.data?.message || "Nao foi possivel salvar a atividade.",
            "er",
          );
        }
    };

    
    useEffect(() => {
        if (editingActivity) {
          const a = activities.find((x) => x.id === editingActivity);
          if (a)
            setForm({
              nome: "",
              unidade: "hora",
              ppu_rank: 10,
              ppu_token: 8,
              cor: "#4FB3A9",
              ordem: 0,
              ativo: true,
              periodo: "dia",
              ...a,
              max_token: a.max_token || "",
              max_pts: a.max_pts || "",
            });
        } else
          setForm({
            nome: "",
            unidade: "hora",
            ppu_rank: 10,
            ppu_token: 8,
            cor: "#4FB3A9",
            ordem: 0,
            ativo: true,
            max_token: "",
            max_pts: "",
            periodo: "dia",
          });
      }, [editingActivity, activities]);
      
    return (
        <form onSubmit={submit} className="fc">
          <div
            style={{
              fontWeight: 700,
              color: "#1F4754",
              fontSize: 14,
              marginBottom: 12,
            }}
          >
            {editingActivity ? "Editar" : "Nova"} Atividade
          </div>
          <div className="fg">
            <label>Nome</label>
            <input
              className="inp"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
              required
            />
          </div>
          <div className="fr">
            <div className="fg">
              <label>Unidade</label>
              <select
                className="sel"
                value={form.unidade}
                onChange={(e) => setForm({ ...form, unidade: e.target.value })}
              >
                {[
                  "hora",
                  "questao",
                  "unidade",
                  "pessoa",
                  "minuto",
                  "pagina",
                  "redacao",
                ].map((u) => (
                  <option key={u} value={u}>
                    {u}
                  </option>
                ))}
              </select>
            </div>
            <div className="fg">
              <label>Periodo</label>
              <select
                className="sel"
                value={form.periodo || "dia"}
                onChange={(e) => setForm({ ...form, periodo: e.target.value })}
              >
                <option value="dia">Por dia</option>
                <option value="mes">Por mes</option>
              </select>
            </div>
          </div>
          <div className="fr">
            <div className="fg">
              <label>Pontos/unidade</label>
              <input
                type="number"
                step="0.01"
                min="0"
                className="inp"
                value={form.ppu_rank}
                onChange={(e) => setForm({ ...form, ppu_rank: e.target.value })}
                required
              />
            </div>
            <div className="fg">
              <label>Tokens/unidade</label>
              <input
                type="number"
                step="0.01"
                min="0"
                className="inp"
                value={form.ppu_token}
                onChange={(e) =>
                  setForm({ ...form, ppu_token: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div
            style={{
              background: "#F4F8F9",
              borderRadius: 9,
              padding: "11px",
              marginBottom: 11,
              border: "1.5px solid #E0E8EB",
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                color: "#1F4754",
                marginBottom: 9,
              }}
            >
              Limites{" "}
              <span
                style={{
                  background: "#4FB3A9",
                  color: "#FFF",
                  fontSize: 9,
                  fontWeight: 700,
                  borderRadius: 999,
                  padding: "2px 7px",
                  marginLeft: 5,
                }}
              >
                ADMIN
              </span>
            </div>
            <div className="fr">
              <div className="fg" style={{ marginBottom: 0 }}>
                <label>Max tokens/{form.periodo || "dia"}</label>
                <input
                  type="number"
                  min="0"
                  className="inp"
                  value={form.max_token}
                  onChange={(e) =>
                    setForm({ ...form, max_token: e.target.value })
                  }
                  placeholder="vazio = sem limite"
                  style={{ background: "#FFF" }}
                />
              </div>
              <div className="fg" style={{ marginBottom: 0 }}>
                <label>Max pontos/{form.periodo || "dia"}</label>
                <input
                  type="number"
                  min="0"
                  className="inp"
                  value={form.max_pts}
                  onChange={(e) =>
                    setForm({ ...form, max_pts: e.target.value })
                  }
                  placeholder="vazio = sem limite"
                  style={{ background: "#FFF" }}
                />
              </div>
            </div>
            {(form.max_token || form.max_pts) && prev() !== null && (
              <div
                style={{
                  marginTop: 8,
                  padding: "7px 10px",
                  background: "#1F4754",
                  borderRadius: 7,
                  fontSize: 12,
                  color: "rgba(255,255,255,0.85)",
                }}
              >
                <strong style={{ color: "#FFC76B" }}>Maximo real:</strong>{" "}
                {fmtNum(prev())} pontos/{form.periodo || "dia"}
              </div>
            )}
          </div>
          <div className="fr">
            <div className="fg">
              <label>Cor</label>
              <input
                type="color"
                className="inp"
                value={form.cor}
                onChange={(e) => setForm({ ...form, cor: e.target.value })}
              />
            </div>
            <div className="fg">
              <label>Ordem</label>
              <input
                type="number"
                className="inp"
                value={form.ordem}
                onChange={(e) => setForm({ ...form, ordem: e.target.value })}
              />
            </div>
          </div>
          <div className="fg">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                textTransform: "none",
                letterSpacing: "normal",
                fontSize: 13,
                color: "#1F4754",
              }}
            >
              <input
                type="checkbox"
                checked={form.ativo}
                onChange={(e) => setForm({ ...form, ativo: e.target.checked })}
              />{" "}
              Ativa
            </label>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button type="submit" className="btn">
              {editingActivity ? "Atualizar" : "Cadastrar"}
            </button>
            {editingActivity && (
              <button
                type="button"
                className="btn bg"
                onClick={() => setEditingActivity(null)}
              >
                Cancelar
              </button>
            )}
          </div>
        </form>
    )
}

